import { Component, computed, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { FacilityService } from '../../../services/facility.service';

@Component({
  selector: 'app-facility-select',
  imports: [FormsModule, SelectModule],
  templateUrl: './facility-select.component.html',
})
export class FacilitySelectComponent {

  private readonly facilityService = inject(FacilityService);

  readonly facilities = this.facilityService.facilities;

  readonly hasChoice = this.facilityService.hasChoice;

  readonly selectedId = this.facilityService.selectedId;

  readonly selectedName = computed(() => this.facilityService.selected()?.name ?? '');
}
